import { useEffectWithCleanup, useRef, useState } from "Shared/haunted/CustomHooks";

export const useManualCountdown = () => {
	const startTimeRef = useRef<number>(Date.now());
	const durationTimeRef = useRef<number>(0);

	const [remainingTime, setRemainingTime] = useState<number>(0);

	const startCountdown = (time: number) => {
		startTimeRef.current = Date.now();
		durationTimeRef.current = time;
		setRemainingTime(time);
	};

	const updateRemainingTime = () => {
		const elapsed = Math.floor(Date.now() - startTimeRef.current);
		const remaining = Math.max(durationTimeRef.current - elapsed, 0);

		setRemainingTime(remaining);
	};

	useEffectWithCleanup(() => {
		const intervalId = window.setInterval(updateRemainingTime, 1000);
		return () => window.clearInterval(intervalId);
	}, []);

	useEffectWithCleanup(() => {
		const onVisibilityChange = () => {
			if (document.visibilityState === "visible") {
				updateRemainingTime();
			}
		};
		document.addEventListener("visibilitychange", onVisibilityChange);
		return () => document.removeEventListener("visibilitychange", onVisibilityChange);
	}, []);

	return {
		isCountdownFinished: remainingTime === 0,
		remainingSeconds: Math.floor((remainingTime / 1000) % 60),
		remainingMinutes: Math.floor(remainingTime / 1000 / 60),
		startCountdown,
	};
};
